import { NgModule } from '@angular/core';
import { BodyanalyticsBaseComponent } from './components/bodyanalytics-base/bodyanalytics-base.component';
import { MainNavComponent } from './shell/main-nav/main-nav.component';
import { NavComponent } from './shell/nav/nav.component';
import { LoginButtonComponent } from './shell/login-button/login-button.component';
import { LogoutButtonComponent } from './shell/logout-button/logout-button.component';
import { SignupButtonComponent } from './shell/signup-button/signup-button.component';
import { MemberButtonComponent } from './shell/member-button/member-button.component';
import { HeaderComponent } from './shell/header/header.component';
import { ProfileButtonComponent } from './shell/profile-button/profile-button.component';
import { AdminMemberButtonComponent } from './shell/admin-member-button/admin-button.component';
import { CalendarButtonComponent } from './shell/calendar-button/calendar-button.component';
import { LoadingSpinnerComponent } from './shared-components/loading-spinner/loading-spinner.component';
import { ModalComponent } from './components/modal/modal.component';
import { GenericFormComponent } from './components/generic-form/generic-form.component';
import { GenericDashboardComponent } from './components/generic-dashboard/generic-dashboard.component';
import { GenericTableComponent } from './components/generic-table/generic-table.component';
import { BookingCancelDialogComponent } from './components/dialogs/booking-cancel-dialog/booking-cancel-dialog.component';
import { BookingRescheduleDialogComponent } from './components/dialogs/booking-reschedule-dialog/booking-reschedule-dialog.component';
import { PhoneMaskDirective } from './directives/phone-number.directive';
import { TimerComponent } from './components/timer/timer.component';
import { AmPmPipe } from './pipes/time-format.pipe';
import { FooterComponent } from './shell/footer/footer.component';
import { PhonePipe } from './pipes/phone.pipe';

/**
 * UiCoreModule — backward-compatibility barrel module.
 *
 * All components are now standalone. This module simply imports and
 * re-exports them so that existing consumers (other NgModules that
 * import UiCoreModule) continue to work without changes.
 *
 * New code should import standalone components directly instead of
 * importing this module.
 *
 * @deprecated Import standalone components directly instead.
 */
@NgModule({
  imports: [
    BodyanalyticsBaseComponent,
    NavComponent,
    MainNavComponent,
    LogoutButtonComponent,
    LoginButtonComponent,
    SignupButtonComponent,
    MemberButtonComponent,
    HeaderComponent,
    ProfileButtonComponent,
    AdminMemberButtonComponent,
    CalendarButtonComponent,
    LoadingSpinnerComponent,
    ModalComponent,
    GenericFormComponent,
    GenericDashboardComponent,
    GenericTableComponent,
    BookingCancelDialogComponent,
    BookingRescheduleDialogComponent,
    PhoneMaskDirective,
    TimerComponent,
    AmPmPipe,
    PhonePipe,
    FooterComponent,
  ],
  exports: [
    BodyanalyticsBaseComponent,
    NavComponent,
    MainNavComponent,
    HeaderComponent,
    LoadingSpinnerComponent,
    ModalComponent,
    PhoneMaskDirective,
    GenericFormComponent,
    GenericDashboardComponent,
    GenericTableComponent,
    BookingCancelDialogComponent,
    BookingRescheduleDialogComponent,
    TimerComponent,
    AmPmPipe,
    PhonePipe,
    FooterComponent,
  ],
})
export class UiCoreModule {}
